// src/components/kyc/ApplicantEntityInfoStep.tsx
import React from "react";
import GlobalTextInputField from "../../components/GlobalTextInputField";
import { Step2State } from "../../types/types";



type Props = {
    value: Step2State;
    onChange: (patch: Partial<Step2State>) => void;

};

const ApplicantEntityInfoStep: React.FC<Props> = ({ value, onChange }) => {
    return (
        <div className="space-y-4">
            <p className="text-text-base text-[10px]">This email address will serve as the primary access credential for the account. It should belong to a key managerial person (e.g., founder, director, or senior manager) who has authority and oversight of the entity. Please ensure access is controlled and monitored, as all login credentials, notifications, and system communications will be linked to this email.</p>
            <div className="grid grid-cols-2 gap-x-4 gap-y-4">
                {/* LEGAL ENTITY NAME */}
                <div className="flex flex-col ">
                    <GlobalTextInputField
                        title="Account Access Email Id"
                        value={value.accountAccessEmailId}
                        onChange={(e: { target: { value: any } }) => onChange({ accountAccessEmailId: e.target.value })}
                        placeholder="Enter email id"
                        showBorder
                    />
                </div>
            </div>
        </div>
    );
};

export default ApplicantEntityInfoStep;
